import styled from "styled-components";

export const ConatinerPolicyPrivacy = styled.div`
  background: #fff;
  border-radius: 20px;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    max-width: 1024px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 1440px) {
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;

export const TitlePolicyPage = styled.h1`
  font-size: 20px;
  font-family: "Exo2 Bold";

  @media (min-width: 1440px) {
    font-size: 32px;
    line-height: 1.18;
  }
`;
